import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Camera, Sparkles, Phone, MapPin, ArrowRight, Menu, X } from 'lucide-react';
import { beforeAfterImages } from '../mockData';

const Gallery = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Premium Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-950/98 via-emerald-950/95 to-slate-950/98 backdrop-blur-xl border-b border-emerald-500/20 shadow-[0_4px_30px_rgba(16,185,129,0.15)]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20 md:h-28">
            <Link to="/" className="flex items-center group -ml-2 md:-ml-4 mt-1 md:mt-2">
              <div className="relative">
                <div className="absolute -inset-2 md:-inset-3 bg-gradient-to-r from-emerald-500/40 via-green-400/30 to-emerald-500/40 rounded-2xl blur-xl opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="relative h-16 md:h-24 w-auto rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_60px_rgba(16,185,129,0.3)] border-2 border-emerald-400/30"
                  style={{filter: 'drop-shadow(0 0 20px rgba(16,185,129,0.4))'}}
                />
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/services" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Services
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/gallery" className="relative text-emerald-400 font-bold text-sm uppercase tracking-wider">
                Gallery
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-emerald-400 to-green-400"></span>
              </Link>
              <Link to="/values" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Our Values
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/testimonials" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Testimonials
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/faq" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                FAQ
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Button 
                onClick={scrollToContact} 
                className="relative overflow-hidden bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 hover:from-emerald-500 hover:via-green-400 hover:to-emerald-500 text-white font-bold px-8 py-3 rounded-full shadow-[0_4px_20px_rgba(16,185,129,0.4)] transition-all duration-300 border border-emerald-400/30"
              >
                Get a Quote
              </Button>
            </nav>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-white hover:text-emerald-400 transition-colors"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-slate-950 border-b border-emerald-500/20 shadow-2xl z-50">
            <nav className="container mx-auto px-6 py-6 flex flex-col gap-1">
              <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Services</Link>
              <Link to="/gallery" onClick={() => setMobileMenuOpen(false)} className="text-emerald-400 font-semibold text-lg py-3 px-4 rounded-lg bg-emerald-500/10">Gallery</Link>
              <Link to="/values" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Our Values</Link>
              <Link to="/testimonials" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Testimonials</Link>
              <Link to="/faq" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">FAQ</Link>
              <Button onClick={() => { scrollToContact(); setMobileMenuOpen(false); }} className="mt-4 bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 text-white font-bold px-8 py-3 rounded-full shadow-lg">Get a Quote</Button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section - Unique masonry-style design */}
      <section className="relative pt-24 pb-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950"></div>
        {/* Floating camera icons */}
        <div className="absolute top-40 right-20 opacity-10">
          <Camera className="w-32 h-32 text-emerald-400" />
        </div>
        <div className="absolute bottom-20 left-20 opacity-10">
          <Sparkles className="w-24 h-24 text-green-400" />
        </div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10 pt-20">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8">
              <Camera className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm font-semibold uppercase tracking-widest">Portfolio</span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
              Our <span className="bg-gradient-to-r from-emerald-400 via-green-300 to-emerald-400 bg-clip-text text-transparent">Work</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
              See the transformations we've created for homeowners and businesses across Alberta.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid - Premium Masonry Style */}
      <section className="relative py-24 px-4 lg:px-8 bg-gradient-to-b from-slate-950 to-slate-900">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-2 gap-10">
            {beforeAfterImages.map((project, index) => (
              <Card key={project.id} className="group relative overflow-hidden bg-slate-800/50 backdrop-blur-sm border-2 border-slate-700/50 hover:border-emerald-500/50 rounded-3xl transition-all duration-500 hover:shadow-[0_30px_80px_rgba(16,185,129,0.2)]">
                {/* Image Container */}
                <div className="relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent z-10 opacity-60 group-hover:opacity-40 transition-opacity duration-500"></div>
                  <img 
                    src={project.before} 
                    alt={project.title}
                    className="w-full h-80 object-contain bg-slate-900 group-hover:scale-105 transition-transform duration-700"
                  />
                  {/* Premium badge */}
                  <div className="absolute top-6 left-6 z-20">
                    <div className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-green-600 rounded-full shadow-lg">
                      <span className="text-sm font-bold text-white uppercase tracking-wider">Before & After</span>
                    </div>
                  </div>
                  {/* Hover reveal */}
                  <div className="absolute inset-0 flex items-center justify-center z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="w-16 h-16 bg-emerald-500/20 backdrop-blur-xl rounded-full flex items-center justify-center border border-emerald-400/50">
                      <Sparkles className="w-8 h-8 text-emerald-400" />
                    </div>
                  </div>
                </div>
                
                {/* Content */}
                <CardHeader className="relative z-20 -mt-8 mx-6 mb-6 bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 border border-slate-700/50 group-hover:border-emerald-500/30 transition-colors">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-8 h-1 bg-gradient-to-r from-emerald-400 to-green-400 rounded-full"></div>
                  </div>
                  <CardTitle className="text-2xl font-black text-white mb-2 group-hover:text-emerald-400 transition-colors">{project.title}</CardTitle>
                  <CardDescription className="text-gray-400 text-base">{project.description}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
          
          {/* More work coming soon */}
          <div className="mt-16 text-center">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-slate-800/50 border border-slate-700 rounded-full">
              <Sparkles className="w-5 h-5 text-emerald-400" />
              <span className="text-gray-300 font-medium">More projects added regularly</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 px-4 lg:px-8 overflow-hidden bg-slate-950">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/20 via-green-900/20 to-emerald-900/20"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
        
        <div className="container mx-auto text-center relative z-10">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-6">Want Results Like These?</h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto">
            Let us transform your property into something spectacular.
          </p>
          <Button 
            onClick={scrollToContact} 
            size="lg" 
            className="bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 text-white px-10 py-7 text-xl font-bold rounded-2xl shadow-[0_8px_40px_rgba(16,185,129,0.4)] transition-all duration-300"
          >
            Start Your Project
            <ArrowRight className="ml-3 w-6 h-6" />
          </Button>
        </div>
      </section>

      {/* Premium Footer */}
      <footer className="relative bg-gradient-to-b from-slate-900 to-black text-gray-300 pt-20 pb-8 px-4 lg:px-8">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
        
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-16">
            <div className="md:col-span-2">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="h-16 w-auto rounded-xl"
                />
                <div>
                  <span className="text-lg font-black text-white">TRUE NORTH</span>
                  <span className="block text-xs text-emerald-400 tracking-[0.2em]">ALBERTA PROPERTY SERVICES</span>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed max-w-md">
                Professional landscaping and snow removal services for Alberta properties. Quality work, reliable service, year-round excellence.
              </p>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Quick Links</h3>
              <ul className="space-y-3">
                <li><Link to="/services" className="text-gray-400 hover:text-emerald-400 transition-colors">Services</Link></li>
                <li><Link to="/gallery" className="text-gray-400 hover:text-emerald-400 transition-colors">Gallery</Link></li>
                <li><Link to="/values" className="text-gray-400 hover:text-emerald-400 transition-colors">Our Values</Link></li>
                <li><Link to="/testimonials" className="text-gray-400 hover:text-emerald-400 transition-colors">Testimonials</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Contact</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-emerald-400" />
                  <span className="text-gray-400">Calgary & Surrounding Areas</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-emerald-400" />
                  <a href="tel:5873252799" className="text-gray-400 hover:text-emerald-400 transition-colors">587-325-2799</a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-slate-800 pt-8 text-center">
            <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} True North Alberta Property Services. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Gallery;
